import React from "react";
import { connect, useSelector } from "react-redux";
import NetworkContainer from "../../components/NetworkContainer/NetworkContainer";

function Network(props) {
  const user = useSelector((state) => state.appReducer.userDataReducer.data);
  const { type } = props;
  return (
  <>
    <NetworkContainer type={type} />
    </>
  );
}

export default Network;
